// extracted by mini-css-extract-plugin
export var subtitle = "_ar-2";
export var title = "_ar-0";
export var titleNoWrap = "_ar-1";